import {Component} from '@angular/core';

@Component({
  selector: 'faqs',
  templateUrl: './faqs.component.html',
  styleUrls: ['./faqs.component.scss']
})
export class FaqsComponent {
  list = [
    {
      title: $localize`How do I get paid for my sales?`,
      subtitle: $localize`Payments are processed securely through our platform and transferred directly to your bank account. You\'ll have access to a dashboard to track your earnings in real-time.`
    },
    {
      title: $localize`What if I don’t have delivery capabilities?`,
      subtitle: $localize`No worries! Our platform partners with leading delivery services to ensure your food reaches customers. You cook, we deliver – it\'s that simple.`
    },
    {
      title: $localize`Can I set my own prices?`,
      subtitle: $localize`Absolutely. You have full control over your menu pricing. We provide guidelines and best practices to help you set competitive prices.`
    },
    {
      title: $localize`Are there any fees to join the platform?`,
      subtitle: $localize`Joining our community is free. We charge a small commission on orders to cover marketing, support, and platform maintenance, ensuring you get maximum exposure.`
    },
    {
      title: $localize`How can I ensure my food stands out?`,
      subtitle: $localize`We offer resources on food photography, menu optimization, and customer engagement strategies to help your offerings shine.`
    },
  ]
}
